import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { getSeoReportByMonth, getSeoReportList, SeoReportList, SeoReportResponse, SeoReportTask } from '../../services/seo-report';
import ViewSeoReport from './components/SeoReport';
import Section from '../../components/Section';
import SidebarLayout from '../../components/SideBarLayout';

const Home: React.FC = () => {
    const [activeKey, setActiveKey] = useState<number | null>(null);
    const { authState } = useAuthContext();
    const [seoReports, setSeoReports] = useState<SeoReportList>();
    const [currentReportTask, setCurrentReportTask] = useState<SeoReportTask>()
    const [currentReport, setCurrentReport] = useState<SeoReportResponse>();

    const getSeoReports = async () => {
        if (authState.user && authState.user.email) {
            const reports = await getSeoReportList(authState.user.email, authState.user.token)
            console.log({ reports })
            setSeoReports(reports)
        }
    }

    const getSeoReportView = async () => {
        if (authState.user && authState.user.email && activeKey && seoReports) {
            const reportItem = seoReports.find((report) => report.id === activeKey);
            setCurrentReportTask(reportItem);
            if (reportItem) {
                const report = await getSeoReportByMonth(authState.user.email, reportItem.id, authState.user.token)
                setCurrentReport(report);
            }
        }
    }

    useEffect(() => {
        getSeoReports();
        if (activeKey) {
            getSeoReportView()
        }
    }, [authState, authState.isAuthenticated, activeKey])

    return (
        <SidebarLayout sidebarContent={
            <>
                <h2 className="text-lg text-gray-600 font-semibold mb-4 pt-4">Reports</h2>
                <ul>
                    {seoReports && seoReports.map((report) => (
                        <li
                            key={report.id}
                            onClick={() => setActiveKey(report.id)}
                            className={`cursor-pointer p-2 rounded ${activeKey === report.id
                                ? 'bg-blue-100 text-primary-800'
                                : 'hover:bg-primary-700'}`}
                        >
                            {report.parameters.month}
                        </li>
                    ))}
                </ul>
            </>
        }

            mainContent={
                <div>
                    {activeKey ? (
                        <Section title={`SEO Report ${currentReportTask?.id}`}>
                            <ViewSeoReport seoReportResponse={currentReport} />
                        </Section>
                    ) : (
                        authState.isAuthenticated ? (
                            <>
                                <h2>Hi {authState.user?.given_name}</h2>
                                <h4>Welcome To Spear Growth SEO Report Dashboard</h4>
                                <p className="text-primary-200">
                                    Please select a report to view
                                </p>
                            </>
                        ) : (
                            <p>Please login to continue</p>
                        )
                    )}
                </div >
            }
        />
    )
};

export default Home; 